module.exports = __webpack_public_path__ + "static/media/icon_defender.694bcd95.svg";